/**
 * created by li si yi
 * 投稿稿件待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class TggjStoryEditor extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        // console.log('投稿稿件11111111111', data);
        this.data = data;
        if (this.data && this.data.data && this.data.data.id && this.data.data.targetIds && this.data.data.targetIds.length && this.data.activitiCategoryKey === "tggj") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'ContributeIcon';
        return icon
    };
    handle = (data, call) => {
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.tglc", "activitiTreeRoot-xlc-tglc");
        let storyEditorConfig = this.sysConfigGetValueByKey("editor.config.story", "");
        try {
            storyEditorConfig = JSON.parse(activitiConfName);
        } catch (e) {
            console.log(e.toString())
        }
        window.openEditById({
            params: {activitiConfName},
            configName: data.data.openEditorStyle ? data.data.openEditorStyle : (storyEditorConfig?.configName ? storyEditorConfig?.configName : "storyEditor"),
            id: data.data.id
        });
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                call && call();
            }
        }, "ManuscriptsSubmitted")
    };

    render() {
        return (
            <div style={{display: 'none'}}>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}


export default connect(mapStateToProps, null, null, {forwardRef: true})(TggjStoryEditor)